export const MIGRATION_TYPE = {
  VIEW: 'view',
}
